// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".heatmap-primitive .cell-selected\r\n{\r\n    outline:1px solid black;\r\n    outline-offset:-1px;\r\n    -webkit-box-shadow: inset 0px 0px 10px 2px rgba(0,0,0,0.75);\r\n    -moz-box-shadow: inset 0px 0px 10px 2px rgba(0,0,0,0.75);\r\n    box-shadow: inset 0px 0px 10px 2px rgba(0,0,0,0.75);\r\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
